import $ from './jquery-global.js';

var modalOpenedHandlerBound = false;

function getSecretWordModal(trigger) {
  if (!trigger) return null;

  var form = trigger.closest('form');
  if (!form) return null;

  return form.querySelector('.secret_word.modal');
}

function focusSecretWord(modalId) {
  var modal = modalId ? document.getElementById(modalId) : document.querySelector('.secret_word.modal');
  if (!modal) return;

  var secretWord = modal.querySelector('input[name="secret_word"]');
  if (!secretWord) return;

  setTimeout(function() {
    secretWord.focus();
    if (secretWord.select) secretWord.select();
  }, 0);
}

function openSecretWordModal(event) {
  event.preventDefault();

  var modal = getSecretWordModal(event.currentTarget);
  if (!modal) return;

  if (!modal.classList.contains('hidden')) return;

  if (window.ModalManager && typeof window.ModalManager.open === 'function') {
    window.ModalManager.open(modal, event.currentTarget);
  }
}

function handleModalOpened(event) {
  focusSecretWord(event.detail && event.detail.modalId);
}

function bindModalLifecycle() {
  if (modalOpenedHandlerBound) return;

  document.addEventListener('modal:opened', handleModalOpened);
  modalOpenedHandlerBound = true;
}

function unbindModalLifecycle() {
  if (!modalOpenedHandlerBound) return;

  document.removeEventListener('modal:opened', handleModalOpened);
  modalOpenedHandlerBound = false;
}

function bindSecretWordForm() {
  $(document)
    .off('click.secret_word', '.require_secret_word')
    .on('click.secret_word', '.require_secret_word', openSecretWordModal);

  $(document)
    .off('keydown.secret_word', '.js--secretWord')
    .on('keydown.secret_word', '.js--secretWord', function(event) {
      event.stopImmediatePropagation();
      if (event.keyCode === 13) {
        event.preventDefault();
        $(event.target).closest('form').find('input[type=submit]').click();
      }
    });
}

bindModalLifecycle();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindSecretWordForm);
} else {
  bindSecretWordForm();
}

document.addEventListener('turbolinks:load', bindSecretWordForm);
document.addEventListener('turbo:load', bindSecretWordForm);
document.addEventListener('turbolinks:load', bindModalLifecycle);
document.addEventListener('turbo:load', bindModalLifecycle);
document.addEventListener('turbo:before-cache', unbindModalLifecycle);
document.addEventListener('turbolinks:before-cache', unbindModalLifecycle);
window.addEventListener('pagehide', unbindModalLifecycle);
